export default "__VITE_ASSET__DASu0eze__"